<template>
    <MonitorLayoutTemplate
        :table_title="table_title"
    >
        <template #datetime>
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>

        <template #data_table="slot_props">
            <QpeDatatable
                :data="table_data"
                :headers="header"
                :name="default_value"
                :error_text="error_text"
                :search="slot_props.search"
                :should_show_raw_html_header="should_show_raw_html_header"
                :enable_diagram_slot="true"
                :enable_table_label="true"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </template>
    </MonitorLayoutTemplate>
</template>

<script>
    import { redirect_monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { TABLE_VALUE_TEXT_MAPPING } from "@/config/monitor_config.js"
    import MonitorLayoutTemplate from "@/components/monitor/_tool/layout_template.vue"
    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import QpeDatatable from "../qpe_datatable.vue"

    export default {
        name: 'ShortTermRainfall',

        components: {
            MonitorLayoutTemplate,
            QpeDatetime,
            QpeDatatable
        },

        mixins: [monitor_mixin],

        data() {
            return {
                header: [],
                table_data: [],
                default_value: 267,
                error_text: '',

                should_show_raw_html_header: ['雷達狀態'],        
                
                search: ''
            }
        },
        
        computed: {
            table_title() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}資訊`
            }
        },

        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },
        
        methods: {
            generate_table_data(data, header) {
                this.table_data = this.reconstruct_alert_content(data);
                this.header = header;
            },

            reconstruct_alert_content (data) {
                let processed_data = data.map(d => {
                    if (d['雷達狀態'] == '0') {
                        d['雷達狀態'] = [{
                            html: `<span class="dot" style="background: #00ff00"/>`,
                            center: true
                        }];
                    } 
                    else if (d['雷達狀態'] == '2') {
                        d['雷達狀態'] = [{
                            html: `<span class="dot" style="background: #ff0000"/>`,
                            center: true
                        }];
                    } 
                    else {
                        d['雷達狀態'] = [{
                            html: `<span> ? </span>`,
                            center: true
                        }];
                    } 
                    return d
                })
                return processed_data
            },
        },
    }
</script>